import React, { PureComponent } from 'react'
import { func } from 'prop-types'
import Form from '@active/react-ui/Form'
import FormGroup from '@active/react-ui/FormGroup'
import FormLabel from '@active/react-ui/FormLabel'
import FormStaticField from '@active/react-ui/FormStaticField'
import { Locale, withI18n } from '@active/react-utils/i18n'
import { paymentMethodPropType } from '../../../../common/paymentMethodTypes'

import './SavedECheck.scss'

const formatter = (name = 'label') => <Locale id={`passport.lib.components.payment.echeck.${name}`} />
class SavedECheck extends PureComponent {
  static propTypes = {
    paymentMethod: paymentMethodPropType.isRequired,
    i18n: func.isRequired,
  }

  render() {
    const { paymentMethod, i18n } = this.props
    return (
      <div className="checkout__saved-ec checkout-payments">
        <Form horizontal initialValues={paymentMethod}>
          <FormGroup>
            <FormLabel><Locale id="passport.lib.components.payment.ecpeudd.type" /></FormLabel>
            <FormStaticField name="paymentType" formatter={formatter} />
          </FormGroup>
          <FormGroup>
            <FormLabel><Locale id="passport.lib.components.payment.echeck.account" /></FormLabel>
            <FormStaticField
              name="last2Digits"
              formatter={name => (i18n('passport.lib.components.payment.4asterisk') + name)}
            />
          </FormGroup>
          <FormGroup>
            <FormLabel><Locale id="passport.lib.components.payment.echeck.name" /></FormLabel>
            <FormStaticField name="accountName" />
          </FormGroup>
          <FormGroup>
            <FormLabel><Locale id="passport.lib.components.payment.echeck.type" /></FormLabel>
            <FormStaticField
              // Link to
              // passport.lib.components.payment.echeck.CONSUMER_CHECKING
              // passport.lib.components.payment.echeck.CORPORATE_CHECKING
              // passport.lib.components.payment.echeck.CONSUMER_SAVINGS
              // passport.lib.components.payment.echeck.CORPORATE_SAVINGS
              name="accountType"
              formatter={formatter}
            />
          </FormGroup>
        </Form>
      </div>
    )
  }
}

export default withI18n(SavedECheck)
